import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/survey.css';

function SurveyComplete() {
  const [userData, setUserData] = useState(null);
  
  useEffect(() => {
    // 从localStorage加载问卷数据
    const savedData = localStorage.getItem('personalQuestionnaireData');
    if (savedData) {
      setUserData(JSON.parse(savedData));
    }
  }, []);
  
  // 根据用户选择的技能返回建议的场景类型
  const getSuggestedScenarios = (skills) => {
    if (!skills || skills.length === 0) return "various social scenarios";
    
    if (skills.includes('conflict-resolution')) return "conflict resolution scenarios";
    if (skills.includes('public-speaking')) return "public speaking situations";
    if (skills.includes('networking')) return "networking opportunities";
    
    return "social interaction scenarios";
  };
  
  // 根据用户职业返回个性化描述
  const getOccupationDescription = (occupation) => {
    const descriptions = {
      'student': "as a student navigating academic and social environments",
      'business': "in professional business settings",
      'creative': "in creative and collaborative environments",
      'technical': "in technical and team-based settings",
      'management': "as a leader guiding your team",
      'entrepreneur': "as an entrepreneur building connections"
    };
    
    return descriptions[occupation] || "in various professional contexts";
  };
  
  return (
    <div className="transition-container">
      <div className="transition-content">
        <div className="success-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
        </div>
        
        <h1>Personal Profile Complete!</h1>
        <p className="subtitle">Thank you for sharing your preferences with us.</p>
        
        {userData && (
          <div className="profile-summary">
            <h2>Your Personal Profile</h2>
            
            <div className="summary-card">
              <h3>About You</h3>
              <p>
                <strong>Age Group:</strong> {userData.ageRange}
              </p>
              <p>
                <strong>Occupation:</strong> {userData.occupation?.split('-').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join(' ')}
              </p>
            </div>
            
            <div className="summary-card">
              <h3>Your Focus Areas</h3>
              <ul className="skills-list">
                {userData.skillsToImprove?.map(skill => (
                  <li key={skill} className="skill-tag">
                    {skill.split('-').map(word => 
                      word.charAt(0).toUpperCase() + word.slice(1)
                    ).join(' ')}
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="personalized-note">
              <h3>Your Personalized EQ Journey</h3>
              <p>
                Based on your profile, we've customized your experience to focus on 
                <strong> {getSuggestedScenarios(userData.skillsToImprove)}</strong> 
                {userData.occupation ? ` ${getOccupationDescription(userData.occupation)}` : ""}.
              </p>
              <p>
                Your communication style ({userData.communicationStyle?.split('-').map(word => 
                  word.charAt(0).toUpperCase() + word.slice(1)
                ).join(' ')}) will be considered in our recommendations and analysis.
              </p>
            </div>
          </div>
        )}
        
        <div className="info-card">
          <h2>Next Step: Take Your EQ Assessment</h2>
          <p>Now that we understand your background and goals, let's measure your emotional intelligence in real-world scenarios.</p>
          
          <ul className="benefits-list">
            <li>
              <span className="icon">📊</span>
              <span>Complete a 15-minute interactive assessment</span>
            </li>
            <li>
              <span className="icon">🧠</span>
              <span>Test your emotional intelligence in practical situations</span>
            </li>
            <li>
              <span className="icon">📈</span>
              <span>Receive a detailed analysis of your emotional intelligence strengths</span>
            </li>
            <li>
              <span className="icon">🎯</span>
              <span>Get personalized recommendations for improvement</span>
            </li>
          </ul>
        </div>
        
        <Link to="/custom-test" className="start-test-button">
          Start My Customized Assessment
        </Link>
        
        <p className="privacy-note">
          Your results are private and will only be used to enhance your experience.
        </p>
      </div>
    </div>
  );
}

export default SurveyComplete; 